
var activeClass = 'is-expanded';
var animTime    = 400;


//
// Expander Widget
//
// Collapse/expand mechanism. Support text-switching as well.
//

module.exports = function Expander ($host, config) {

  // DOM

  var dom = {
    expanders: $('[data-expander-region]', $host),
    triggers:  $('[data-expander-trigger]', $host)
  };


  // State

  var state = { open: false };
  var callbacks = [];


  // Functions

  function setTriggerState (mode) {
    dom.triggers.each(function (ix, trigger) {
      if (trigger.dataset.expandedText) {
        trigger.textContent = mode ? trigger.dataset.expandedText : trigger.dataset.collapsedText
      }
    });
  }

  function setRegionState (mode) {
    dom.expanders.each(function () {
      var $target = $(this);
      $target.css('max-height', mode ? 'none' : $target.data('collapsed-height'));
    });
  }

  function setState (mode) {
    $host.toggleClass(activeClass);
    state.open = mode;
    setRegionState(mode);
    setTriggerState(mode);
    callbacks.map(function (λ) { λ(mode); });
  }

  function toggle () {
    setState(!state.open);
  }


  // Listeners

  dom.triggers.on('click', toggle);


  // Init

  dom.triggers.each(function (ix, trigger) {
    if (trigger.dataset.expandedText) {
      trigger.dataset.collapsedText = trigger.textContent.trim();
    }
  });

  if (isdef(config.beginOpen)) {
    setState(true);
  } else {
    setState(false);
  }


  // Interface

  return {
    open: function () { setState(true) },
    close: function () { setState(false) },
    toggle: toggle,
    onChange: function (λ) { callbacks.push(λ); }
  }

}

